import { render, staticRenderFns } from "./Sazonal.vue?vue&type=template&id=36828b8f&scoped=true&"
import script from "./Sazonal.vue?vue&type=script&lang=js&"
export * from "./Sazonal.vue?vue&type=script&lang=js&"
import style0 from "./Sazonal.vue?vue&type=style&index=0&id=36828b8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36828b8f",
  null
  
)

component.options.__file = "Sazonal.vue"
export default component.exports